import { syncAconContactsByPhone } from '../network/api/privateApi';

export const isReactNativeWebView = () => !!window.ReactNativeWebView;

// 전역 이벤트로 알림 전달
const notifyContactUpload = (isSuccess, count) => {
  const event = new CustomEvent('contactUploaded', {
    detail: { isSuccess, count },
  });
  window.dispatchEvent(event);
};

export const listenAndUploadContactsFromWebView = () => {
  if (!isReactNativeWebView()) return undefined;

  const handleMessage = (event) => {
    try {
      if (typeof event.data === 'string' && event.data.startsWith('[')) {
        const contacts = JSON.parse(event.data);
        // 연락처 배열이 있고 유효한지 확인
        if (Array.isArray(contacts) && contacts.length > 0) {
          // 연락처 데이터를 올바른 형식으로 전송
          // API가 배열을 직접 받는지, 객체 형태로 받는지 확인 필요
          // 일단 배열을 직접 전송하고, 필요시 { phoneNumbers: contacts } 형식도 시도
          syncAconContactsByPhone({ contacts })
            .then((response) => {
              console.log('연락처 업로드 성공:', contacts.length, '개', response?.data);
              notifyContactUpload(true, contacts.length);
            })
            .catch((error) => {
              console.error('연락처 업로드 실패:', error);
              // 첫 번째 시도 실패 시 다른 형식으로 재시도
              if (error.response?.status === 400 || error.response?.status === 422) {
                syncAconContactsByPhone({ phoneNumbers: contacts })
                  .then((response) => {
                    console.log('연락처 업로드 성공 (재시도):', contacts.length, '개', response?.data);
                    notifyContactUpload(true, contacts.length);
                  })
                  .catch((retryError) => {
                    console.error('연락처 업로드 재시도 실패:', retryError);
                    notifyContactUpload(false, 0);
                  });
              } else {
                notifyContactUpload(false, 0);
              }
            });
        }
      }
    } catch (e) {
      console.error('연락처 처리 오류:', e);
    }
  };

  document.addEventListener('message', handleMessage);
  window.addEventListener('message', handleMessage);

  return () => {
    document.removeEventListener('message', handleMessage);
    window.removeEventListener('message', handleMessage);
  };
};

export const requestContactsFromNative = () => {
  if (!isReactNativeWebView()) return;
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage('CONTACT_SEND');
  }
};
